import { component, computed, observable } from 'knockout-decorators'

import { type Offer, PaymentMode } from '@tixa/schema'

import './item'
import '../coupon'
import source from './template.html?raw'
import { CartState } from '../state'
import { Language } from '~/utils'

@component('cart-summary', source)
export class CartSummary {
  @observable public paymentMode = PaymentMode.card
  @observable public allowPartialBalanceUse = false

  private cartState: CartState = CartState.get()

  private readonly cartCategories_1 = ['ticket']
  private readonly cartCategories_2 = ['fee', 'discount']
  private readonly optionalCategories = ['clothing']

  @computed get offers_1(): Offer[] {
    return this.cartState.offers.filter((offer) =>
      this.cartCategories_1.includes(offer.category)
    )
  }

  @computed get currency(): string {
    return this.cartState.offers[0]?.priceCurrency || 'HUF'
  }

  @computed get offers_2(): Offer[] {
    return this.cartState.offers.filter((offer) =>
      this.cartCategories_2.includes(offer.category)
    )
  }

  @computed get allOffers(): Offer[] {
    return [...this.offers_1, ...this.offers_2]
  }

  @computed get shippingOffer(): Offer | undefined {
    return this.cartState.offers.find(
      (offer) => this.cartState.selectedShippingSku === offer.sku
    )
  }

  @computed get optionalOffers(): Offer[] {
    return this.cartState.offers.filter((offer) =>
      this.optionalCategories.includes(offer.category)
    )
  }

  @computed get hasOptionalOffers(): boolean {
    return this.optionalOffers.length > 0
  }

  @computed get totalTouristTax(): number {
    return this.cartState.content?.touristTaxAmount?.total || 0
  }

  @computed get hasTotalTouristTax(): boolean {
    return this.totalTouristTax > 0
  }

  @computed get totalTouristTaxFormatted(): string {
    return Language.formatCurrency(this.totalTouristTax, this.currency)
  }
}
